import { render, staticRenderFns } from "./crole.vue?vue&type=template&id=0aaf1aa6&scoped=true&"
import script from "./crole.vue?vue&type=script&lang=js&"
export * from "./crole.vue?vue&type=script&lang=js&"
import style0 from "./crole.vue?vue&type=style&index=0&id=0aaf1aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf1aa6",
  null
  
)

export default component.exports